import { Dialog } from "@/components/Dialog";
import { Kbd } from "@/components/ui";

const SHORTCUTS: [string, string][] = [
  ["S", "Start / stop the timer"],
  ["N", "New time entry"],
  ["?", "Show this help"],
  ["Esc", "Close dialogs and menus"],
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()} title="Keyboard shortcuts">
      <ul className="space-y-2.5">
        {SHORTCUTS.map(([key, what]) => (
          <li key={key} className="flex items-center justify-between text-sm">
            <span className="text-muted">{what}</span>
            <Kbd>{key}</Kbd>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
